import { render, staticRenderFns } from "./CompanyContractView.vue?vue&type=template&id=0563ed78"
import script from "./CompanyContractView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyContractView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports